export const SKILLS = [
    {
        title: 'Frontend',
        icon: "./assets/images/cv.png",
        skills: [
            {skill: "HTML5", percentage: "80%"},
            {skill: "CSS3", percentage: "90%"},
            {skill: "JavaScript", percentage: "70%"},
            {skill: "React.js", percentage: "85%"},
        ],
    },

    {
        title: 'Backend',
        icon: "../../assets/images/investment.png",
        skills: [
            {skill: "Node.js", percentage: "80%"},
            {skill: "Express.js", percentage: "70%"},
        ],
    },

    {
        title: 'Tools',
        icon: "../../assets/images/portfolio.png",
        skills: [
            {skill: "Git", percentage: "80%"},
            {skill: "Visual Studio Code", percentage: "70%"},
            {skill: "Postman", percentage: "70%"},
            {skill: "Responsive Design", percentage: "70%"},
            {skill: "Webpack", percentage: "55%"},
        ],
    },

    {
        title: 'Soft Skills',
        icon: "../../assets/images/statistic.png",
        skills: [
            {skill: "Communication", percentage: "80%"},
            {skill: "Teamwork", percentage: "80%"},
            {skill: "Leadership", percentage: "85%"},
            {skill: "Problem Solving", percentage: "75%"},
            {skill: "Time Management", percentage: "85%"},
        ],
    }
];


export const WORK_EXPERIENCE = [
    {
        title: "Frontend Developer at Aicansell",
        date: "April 2024 - Present",
        responsibilities: [
            "Managed and developed multiple projects from inception, including the Learning Lens project, Eikomp Website, Aicansell User Panel, and CRM Panel for admins.",
            "Designed and implemented complex front-end architectures using React.js, ensuring scalability and maintainability.",
            "Developed custom components and features to meet specific client requirements, enhancing overall functionality of the applications.",
            "Worked closely with UX/UI designers to create visually appealing and user-friendly interfaces.",
            "Integrated various APIs and handled JSON data structures using Axios, facilitating smooth data interactions.",
            "Conducted thorough testing and debugging to ensure the reliability and performance of applications across different devices and browsers.",
            "Provided mentorship and guidance to junior developers, fostering a collaborative and productive team environment.",
            "Stayed up-to-date with the latest industry trends and technologies, applying new knowledge to improve project outcomes.",
        ],
    },
    {
        title: "Frontend Developer at Netpuppys",
        date: "October 2023 - April 2024",
        responsibilities: [
            "Led the development of the TIS school website, focusing on creating an intuitive and accessible interface for students and teachers.",
            "Developed the Mpire shopping website, enhancing the online shopping experience with interactive features and smooth navigation.",
            "Collaborated with the backend team to integrate APIs, ensuring seamless data flow between the frontend and backend systems.",
            "Utilized React.js to manage state and build dynamic, responsive user interfaces.",
            "Implemented best practices for code maintenance, including modular code design, version control, and documentation.",
            "Participated in daily stand-ups and sprint planning meetings to ensure timely delivery of project milestones.",
        ],
    },
    {
        title: "Frontend Developer at Eikomp",
        date: "April 2023 - October 2023",
        responsibilities: [
            "Transitioned from intern to full-time role after two months due to outstanding performance.",
            "Led the continued development of the Eikomp user panel from scratch, ensuring a user-friendly interface and seamless user experience.",
            "Integrated APIs and managed state using React.js for efficient data handling.",
            "Conducted code reviews and provided feedback to ensure high-quality code and adherence to best practices.",
            "Troubleshot and resolved complex technical issues, improving overall performance and reliability.",
        ],
    },
    {
        title: "Frontend Developer Intern at Eikomp",
        date: "February 2023 - April 2023",
        responsibilities: [
            "Worked on a team of 4 to develop a web application using React.js.",
            "Contributed to the initial setup and architecture of the Eikomp user panel project.",
            "Assisted in integrating APIs provided by the backend team to fetch and display data efficiently.",
        ],
    },
];
